module.exports = __webpack_public_path__ + "assets/visa.ee05e180.png";